export default {
  'verification.welcome.title': '欢迎来到 Knit',
  'verification.welcome.subtitle': '请输入邀请码来开启您的 AI 之旅',
  'verification.input.label': '输入邀请码',
  'verification.submit.loading': '提交中...',
  'verification.hint.terms':
    '通过输入邀请码，您将同意我们的服务条款和隐私政策。',
  'verification.message.success': '验证成功！',
  'verification.message.error': '邀请码错误',
  'verification.message.incomplete': '请输入完整邀请码',

  // 登录消息
  'verification.invalidEmail': '请输入有效的邮箱地址',
  'verification.codeSent': '验证码已发送到您的邮箱',
  'verification.sendCodeFailed': '发送验证码失败，请重试',
  'verification.invalidCredentials': '用户名或密码错误！',
  'verification.loginFailed': '登录失败，请重试！',
  'verification.googleLoginInvalidResponse': 'Google登录失败：响应无效',
  'verification.googleLoginProcessError': 'Google登录失败：处理错误',
  'verification.enterUsernameAndPassword': '请输入用户名和密码',
  'verification.loginSuccessEnteringWorld': '登录成功，正在进入世界...',
  'verification.registerInDevelopment': '注册功能开发中...',
  'verification.guestModeComingSoon': '游客模式即将开放...',
};
